import request from "@/utils/request";

export function checkSession() {
  return request({
    url: "delivery/login/session",
    method: "get",
    skipAuthRedirect: true,
  });
}

export function login(data) {
  return request({
    url: "delivery/login/loginin",
    method: "post",
    data: {
      userName: data.username,
      passWord: data.password,
    },
  });
}

export function logout() {
  return request({
    url: "delivery/login/logout",
    method: "post",
    data: {},
  });
}
